import { Accordion } from "./Accordion";
import { FiltersCheckBox } from "./FiltersCheckBox";

const FAVOURITE_FILTER_IMAGE = "/favoriteFilterImage.png";

type Props = {
  filterOptions: { value: string; isSelected: boolean; name: string; keyWordTitle: string }[];
  handleChooseFilter: (item: { value: string; isSelected: boolean }, isMultiSelect?: boolean) => () => void;
};

const HeartIcon = () => (
  <div
    className="flex items-center justify-center bg-[#F9F7FF] shrink-0 overflow-hidden box-border"
    style={{
      borderRadius: "5.6px 0px 14px 5.6px",
      width: 50,
      height: 50,
      minWidth: 50,
      minHeight: 50,
      maxWidth: 50,
      maxHeight: 50,
    }}
  >
    <img
      src={FAVOURITE_FILTER_IMAGE}
      alt=""
      className="max-w-full max-h-full w-16 h-16 object-contain"
    />
  </div>
);

export const FavouriteFilter: React.FC<Props> = ({ filterOptions, handleChooseFilter }) => {
  if (!filterOptions.length) return null;
  const item = filterOptions[0];
  return (
    <Accordion title={item.keyWordTitle}>
      <div className="flex flex-col gap-3 py-2 md:py-4">
        <div
          role="button"
          tabIndex={0}
          id="filter_show_favourites"
          className="cursor-pointer flex items-center gap-3 pr-3 transition-all duration-300"
          style={{ border: "1px solid #DBE1EB", borderRadius: "6px" }}
          onClick={handleChooseFilter(item, false)}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              handleChooseFilter(item, false)();
            }
          }}
        >
          <HeartIcon />
          <span className="text-[14px] md:text-[16px] flex-1 first-letter:capitalize text-[#0D2C54] font-normal">
            {item.name || "Show my favourite"}
          </span>
          <FiltersCheckBox isSelected={item.isSelected} />
        </div>
      </div>
    </Accordion>
  );
};
